import React, { FC } from "react";
import ReusableAccordian from "../ReusableAccordion";
import SizeLayout from "../SizeLayout";
import PleaseNote from "../PleaseNote";
import { Typography, Paper } from "@mui/material";
import { Image } from "cloudinary-react";
import { RowLayout, ColLayout } from "../../util/accordianStyles";
import { styled } from "@mui/material/styles";
import useWidthSelection from "./useWidthSelection";

const StyledTypography = styled(Typography)({
  fontSize: 20,
  fontWeight: "bold",
  paddingRight: 40,
});

const StyledCloudinaryImage = styled(Image)({
  width: 400,
  height: "auto",
  objectFit: "contain",
});

const CornerUnitSizeAccordian: FC = () => {
 const {
  handleFractionChangeLeft,
  handleFractionChangeRight,
  handleWidthChangeLeft,
  handleWidthChangeRight,
  widthErrCornerRight,
  widthErr,
  cornerType,
  leftWidth,
  rightWidth,
  leftFraction,
  rightFraction
} = useWidthSelection();

  return (
    <ReusableAccordian
      accordionName="unitSize"
      heading="Net Frame Width"
      secondaryHeading=" Select a Width"
      required5={true}
      colOrRow="col"
    >
      <PleaseNote notes="We recommend each Net Frame Width to be 1/2 inch less than the Rough Opening Width" />

      <RowLayout>
        <ColLayout style={{ marginRight: 40 }}>
          <RowLayout>
            <StyledTypography>Left Net Width:</StyledTypography>
            <SizeLayout
              size={leftWidth}
              handleChange={handleWidthChangeLeft}
              sizeErr={widthErr}
              name="width"
              fractionValue={leftFraction || ""}
              handleFractionChange={handleFractionChangeLeft}
            />
          </RowLayout>
          <RowLayout>
            <StyledTypography>Right Net Width:</StyledTypography>
            <SizeLayout
              size={rightWidth || ""}
              handleChange={handleWidthChangeRight}
              sizeErr={widthErrCornerRight}
              name="width"
              fractionValue={rightFraction || ""}
              handleFractionChange={handleFractionChangeRight}
            />
          </RowLayout>
        </ColLayout>

        {cornerType === "Outside" ? (
          <Paper elevation={3}>
            <StyledCloudinaryImage
              cloudName="ag-millworks"
              secure="true"
              publicId="v1691507923/Bifold_Corner_Configs/OUTSIDE_CORNER_DIM_v2"
            />
          </Paper>
        ) : cornerType === "Inside" ? (
          <Paper elevation={3}>
            <StyledCloudinaryImage
              cloudName="ag-millworks"
              secure="true"
              publicId="v1691507925/Bifold_Corner_Configs/INSIDE_CORNER_DIM_v2"
            />
          </Paper>
        ) : null}
      </RowLayout>
    </ReusableAccordian>
  );
};

export default CornerUnitSizeAccordian;
